var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 85,
    viewBox: "0 0 77 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2646 44.1184L34.0521 50.5984L48.5146 34.3984",
    stroke: "#243251",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93945 36.0889C1.93945 23.137 1.93945 16.661 3.47035 14.4821C4.9972 12.3072 11.0844 10.2215 23.2627 6.05405L25.5834 5.26025C31.9297 3.0854 35.1009 2 38.3895 2C41.674 2 44.8492 3.0854 51.1956 5.26025L53.5162 6.05405C65.6946 10.2215 71.7817 12.3072 73.3086 14.4821C74.8395 16.661 74.8395 23.141 74.8395 36.0889V42.4636C74.8395 52.6088 71.4496 60.4334 66.7395 66.4112M2.7211 50.6C6.19195 68.0069 20.4723 76.9777 29.8804 81.0844C32.8005 82.3601 34.2625 83 38.3895 83C42.5205 83 43.9785 82.3601 46.8985 81.0844C49.2435 80.0638 51.8841 78.7354 54.5895 77.0587",
    stroke: "#243251",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/Quality.167a9a3eaf2cfca371dc06fa48ad10fb.svg";
export { ForwardRef as ReactComponent };